import image1 from '@/assets/images/news/detail/20200510/1.jpg';
import image2 from '@/assets/images/news/detail/20200510/2.jpg';
import image3 from '@/assets/images/news/detail/20200510/3.jpg';
import image4 from '@/assets/images/news/detail/20200510/4.jpg';
import image5 from '@/assets/images/news/detail/20200510/5.jpg';
import image6 from '@/assets/images/news/detail/20200510/6.jpg';
import image7 from '@/assets/images/news/detail/20200510/7.png';
import image8 from '@/assets/images/news/detail/20200510/8.png';
import image9 from '@/assets/images/news/detail/20200510/9.png';

export default {
  id: '20200510', //  模块 id
  title: '我们最初的种子是……', // 标题
  content: [
    {
      type: 0,
      text: '3年前，我们种下一颗希望的种子：绝不把不好的菜卖给用户。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '3年来，我们在全体叮咚小伙伴的努力之下，把控品质与服务，不断践行着价值观。',
      isIndent: false,
    },
    {
      type: 0,
      text: '我们立足上海，先后开拓了浙江、江苏、深圳、北京等重要市场……',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '如今的叮咚就像一棵坚韧的小树，迎风生长，期待它成为一棵枝繁叶茂的大树。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '在叮咚买菜三周年庆典仪式上，老梁也再次提到了“种子论”，他说：“我们是坚定的种子论者，我们认为任何事情想要做大，首先种子要选对。如果你是一颗野草种子，虽然你长的很大很快，但是一岁一枯荣。如果你是一颗大树的种子，即使你长得很慢，但是终有一天都会长成参天大树。”',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '那么，叮咚买菜的种子是什么？是绝不把不好的菜卖给用户，这是我们的价值观，也是我们永远不忘且需要长期坚守的初心；叮咚买菜的机会是什么？是我们坚信只有春天播种，秋天才有收获果实的机会。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text:
        '万事没有投机和捷径，如果有投机，就是在种子的时候，发现种子的潜力和未来，早做努力，早早奋斗，让种子成长为大树，这就是唯一的机遇，这也是种子的力量。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: 0,
      text:
        '我们思考种子的力量，相信一颗种子不可能一夜之间成长为参天大树，必须付出奋斗者的汗水，辛勤浇灌。因此有了大事记里记录的Day One的样子，绝不把不好的菜卖给用户；有了对外分享互动游戏，获得的五万多名外部小伙伴的关注和参与。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image3],
    },
    {
      type: 0,
      text:
        '我们思考种子的力量，相信每一名叮咚人，无论是前线后方的哪一个岗位，都在努力用实际的坚守和行动践行着价值观——绝不把不好的菜卖给用户。叮咚买菜文化宣传片里有你，有我，有两万多名叮咚铁军共同见证。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '我们思考种子的力量，相信团结起来才能让这颗好种子更有生长的力量，铁军们无论身处何时何地，都不畏艰难，不断挑战，同目标、共进退、打胜仗！于是有了这一天，嘉年华里铁军们的花式庆祝……',
      isIndent: false,
    },
    {
      type: 0,
      text: '总部同心协力，敏捷专注',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image4],
    },
    {
      type: 0,
      text: '浙江事业部叮咚大事记抢答大比拼',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image5],
    },
    {
      type: 0,
      text: '江苏事业部活鱼鲜虾跳出来',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image6],
    },
    {
      type: 0,
      text: '深圳事业部叮咚灵魂三问，科普一下',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image7],
    },
    {
      type: 0,
      text: '北京事业部 全新出道，就要“C位出道”',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image8],
    },
    {
      type: 0,
      text: '用户价值挖掘中心 分享铁军们的奋斗心路',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image9],
    },
    {
      type: 0,
      text:
        '一颗好种子的力量是无穷的，有些努力短时间是看不出结果，但是我们坚信：“种一棵树，最好的时间是10年前，其次是今天。”',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '绝不把不好的菜卖给用户，是我们始终坚守的种子，是有力量的种子，是春种秋收的种子。',
      isIndent: false,
    },
  ],
};
